import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.39997 16.1536L12 13.5536L14.6 16.1536L15.6538 15.0998L13.0538 12.4998L15.6538 9.89981L14.6 8.84598L12 11.446L9.39997 8.84598L8.34615 9.89981L10.9461 12.4998L8.34615 15.0998L9.39997 16.1536ZM7.3077 20.4998C6.80257 20.4998 6.375 20.3248 6.025 19.9748C5.675 19.6248 5.5 19.1972 5.5 18.6921V5.99981H4.5V4.49983H8.99997V3.61523H15V4.49983H19.5V5.99981H18.5V18.6921C18.5 19.1972 18.325 19.6248 17.975 19.9748C17.625 20.3248 17.1974 20.4998 16.6922 20.4998H7.3077ZM17 5.99981H6.99997V18.6921C6.99997 18.769 7.03203 18.8395 7.09613 18.9037C7.16024 18.9678 7.23077 18.9998 7.3077 18.9998H16.6922C16.7692 18.9998 16.8397 18.9678 16.9038 18.9037C16.9679 18.8395 17 18.769 17 18.6921V5.99981Z",
		fill: "currentColor"
	})]
});
export default SvgDelete;
